export class ItemFamily {
    public itemFamilyId: number;
    public name: string;
    public companyId: number;
    
    public lstFamilia=[];
    public lstSubFamilia=[];
}


// WEBPACK FOOTER //
// ./src/app/models/item-family.ts